import React from 'react';

const AppleIcon: React.FC<
  React.PropsWithChildren<React.SVGProps<SVGSVGElement>>
> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
    >
      <g>
        <path
          fill="currentcolor"
          d="M19.363 8.18c-.14.11-2.656 1.496-2.656 4.574 0 3.562 3.2 4.82 3.297 4.851-.016.079-.512 1.727-1.688 3.407-1.054 1.48-2.152 2.953-3.824 2.953-1.668 0-2.097-.945-4.027-.945-1.88 0-2.547.976-4.078.976-1.528 0-2.594-1.367-3.82-3.047C1.147 18.977 0 15.91 0 13.004c0-4.668 3.105-7.14 6.164-7.14 1.621 0 2.977 1.042 3.996 1.042.969 0 2.485-1.105 4.332-1.105.7 0 3.215.062 4.871 2.379zm-5.75-4.356c.766-.883 1.305-2.113 1.305-3.344 0-.167-.016-.34-.047-.48-1.242.047-2.723.809-3.613 1.82-.7.778-1.356 2.004-1.356 3.25 0 .188.036.375.047.434.082.016.207.031.336.031 1.117 0 2.52-.726 3.328-1.71zm0 0"
        ></path>
      </g>
    </svg>
  );
};

export default AppleIcon;
